import { Select } from "antd";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { WORKSHOP_ICONS } from "./workshop-view";

const badgeOf = (tab) =>
  tab.issues ? (
    <span className="workshop-states__badge">{tab.issues}</span>
  ) : null;

const WorkshopStates = ({
  labels,
  tabs,
  activeKey,
  disabled,
  onSelect,
  newState,
}) => (
  <div className="workshop-states-row">
    <Select
      className="workshop-states"
      popupClassName="workshop-states__popup"
      aria-label={labels.LABEL}
      value={activeKey || undefined}
      disabled={disabled}
      optionLabelProp="display"
      popupMatchSelectWidth={false}
      placement="bottomRight"
      onChange={onSelect}
      options={tabs.map((tab) => ({
        value: tab.key,
        display: (
          <span className="workshop-states__current">
            <span className="workshop-states__name">{tab.name}</span>
            {badgeOf(tab)}
            <span className="workshop-states__when">{tab.when}</span>
          </span>
        ),
        label: (
          <span className="workshop-states__option">
            <span className="workshop-states__name">
              {tab.name}
              {badgeOf(tab)}
            </span>
            <span className="workshop-states__when">{tab.when}</span>
          </span>
        ),
      }))}
    />
    {newState ? (
      <button
        type="button"
        className="workshop-states__add"
        aria-pressed={Boolean(newState.on)}
        disabled={newState.disabled}
        onClick={newState.onToggle}
      >
        <CanvasIcon path={WORKSHOP_ICONS.plus} size={14} strokeWidth={2.4} />
        {labels.NEW}
      </button>
    ) : null}
  </div>
);

WorkshopStates.propTypes = {
  labels: PropTypes.object.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string,
      when: PropTypes.string,
      issues: PropTypes.number,
    }),
  ),
  activeKey: PropTypes.string,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  newState: PropTypes.shape({
    on: PropTypes.bool,
    disabled: PropTypes.bool,
    onToggle: PropTypes.func,
  }),
};

WorkshopStates.defaultProps = {
  tabs: [],
  activeKey: null,
  disabled: false,
  newState: null,
};

export default WorkshopStates;
